import * as React from "react";
import { connect } from "react-redux";
import { Select, TextInput } from "@mantine/core";
import { IGameConfiguration } from "../../types/game/GameConfiguration";

interface OfficialsModeSelectorProps {
  name?: string;
  mode?: string;
  disabled?: boolean;
  onChange: (any) => void;

  /// Fields that are currently in use, used for compatability
  fields: string[];

  // from state
  configs: IGameConfiguration[];
}

const OfficialsModeSelector: React.FunctionComponent<
  OfficialsModeSelectorProps
> = ({ mode, onChange, configs, name, fields, disabled }) => (
  <Select
    name={name}
    value={mode}
    onChange={onChange}
    disabled={disabled}
    data={configs.map((r) => {
      const fieldSet = new Set(r.fields.map((f) => f.identifier));
      const isCompatible = fields ? fields.every((f) => fieldSet.has(f)) : true;
      return {
        value: r._id,
        label: r.friendlyName,
        disabled: !isCompatible
      };
    })}
  />
);

function mapStateToProps(state) {
  return {
    configs: Object.values(state.gameConfigurations.map),
  };
}

export default connect(mapStateToProps)(OfficialsModeSelector);
